import { httpClient } from '../core/http';
import { LlmCatalogResponse } from '../types';

export class LlmService {
  async listAvailable(): Promise<LlmCatalogResponse> {
    const response = await httpClient.get<LlmCatalogResponse>('/v1/llms');
    return response.data;
  }
}
